import { render, staticRenderFns } from "./PageSelector.vue?vue&type=template&id=6a36fb64&"
import script from "./PageSelector.vue?vue&type=script&lang=js&"
export * from "./PageSelector.vue?vue&type=script&lang=js&"
import style0 from "./PageSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports